<mat-form-field>
  <mat-label>{{ 'common.unit' | translate }}</mat-label>
  <mat-select [value]="value" (selectionChange)="change.emit($event.value)">
    <mat-option *ngFor="let unit of units" [value]="unit.value">
      {{ unit.label }}
    </mat-option>
  </mat-select>
</mat-form-field>
